module.exports = __webpack_public_path__ + "static/media/MenuDark.8e5400ff.svg";